
/*
  Sticky ATC
*/
const initStickyAtc = async () => {
  const wrapper = document.querySelector('#sticky-atc')

  if (!wrapper) return

  await new Promise(resolve => setTimeout(resolve, 1000))

    const formEl = document.querySelector('.product-content form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      if (!formEl) return;
        const threshold = formEl.getBoundingClientRect().bottom + window.scrollY

  window.addEventListener('scroll', () => {
    if (window.scrollY > threshold) {
      wrapper.classList.add('show')
      document.body.style.paddingBottom = wrapper.clientHeight + 'px'
    } else {
      wrapper.classList.remove('show')
      document.body.style.paddingBottom = 0
    }
  })
}
initStickyAtc()